import { Storybook } from "@tento-ui/ui/storybook";

import { Column } from "@tento-ui/component-builtin";
import { NATIVE_SKIN } from "../turn/skin";
import { TERMINAL_SKIN } from "../turn-term/skin";
import { DSH_SKIN } from "../turn-dsh/skin";
import { ThreadFixture } from "./fixture";
import type { TurnSlots } from "./slots";

/**
 * The contract's central claim, rendered.
 *
 * `ThreadFixture.renderWith(skin)` is one hand-authored session covering every
 * slot, and `fixture.ts` says both integration storybooks call it "rather than
 * writing their own loop, so neither can quietly skip a row the other
 * renders". Until this file it had **no callers at all** — the claim that one
 * session renders three ways was demonstrated nowhere, and the only way to
 * compare two skins was to read them.
 *
 * Each example below is the same session through a different skin. Read them
 * side by side: what differs is grammar, and what does not differ is the
 * contract doing its job.
 */
function $session(skin: TurnSlots.Skin): HTMLElement {
  const $col = Column.make();
  $col.style.setProperty("gap", "12px");
  $col.style.setProperty("padding", "16px");
  for (const $el of ThreadFixture.renderWith(skin)) $col.appendChild($el);
  return $col;
}

export class ThreadFixtureStoryBook extends Storybook.Default {
  title(): string {
    return "Thread — one session, every skin";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Native skin",
        render: () => $session(NATIVE_SKIN),
      },
      {
        title: "Terminal skin",
        render: () => $session(TERMINAL_SKIN),
      },
      {
        title: "Dsh skin",
        render: () => $session(DSH_SKIN),
      },
    ];
  }
}
